import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { localize, getLocale } from '../../util/Localizer'
import Card from '@material-ui/core/Card'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { withStyles } from '@material-ui/core/styles'
import { Colors } from '../../theme'
import { updateClaim } from '../../redux/actions/submitAClaimActions'

class Terms extends Component {
  constructor () {
    super()
    this.check = this.check.bind(this)
    this.state = { check: false }
  }

  componentDidMount () {
    this.props.setNext(null)
    this.props.setPercent(10)
    this.props.updateUrl('')
    this.props.adjustScrollBar()
  }

  check () {
    if (this.state.check === true) {
      this.props.setNext('member')
    } else {
      this.props.setNext(null)
    }
  }

  render () {
    const loc = getLocale()
    const { appContent = {} } = this.props
    const { contentItemText = {} } = appContent
    const { content = '' } = contentItemText[loc] || {}
    return (
      <Card className='submitCard'>
        <Row start='xs'>
          <Col xs={12}>

            <div dangerouslySetInnerHTML={{ __html: content }}/>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.check}
                  onChange={(e, v) => this.setState({ check: v }, this.check)}
                  value={'true'}
                  color='primary'
                />
              }
              label={localize('pages.SubmitAClaim.TermsAndConditions.agreeToTerms')}
            />
          </Col>
        </Row>
      </Card>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    memberSummary: state.memberSummaryReducer.memberSummary
  }
}
const ConnectedTerms = connect(mapStateToProps, { updateClaim })(injectIntl(Terms))

const styles = {
  heading: {
    color: Colors.primaryColor
  }
}

export default withStyles(styles)(ConnectedTerms)



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/Terms.js